// extracted by mini-css-extract-plugin
export default {"header":"header_header__jb7Y7","nav-link":"header_nav-link__CpBDJ","active":"header_active__-xrkU"};